import React, { useEffect, useState } from "react";

import PageWrapper from "../../components/page-wrapper";

import hcpFavicon from "../../images/hcp-favicon.ico";

import StickyTab from "../../components/sticky-tab";

import EntryModal from "./entry-modal";
import SignUpCTA from "./sign-up-cta";
import GradientCta from "./gradient-cta";
import BasicHero from "./basic-hero";

const HCPPageWrapper = ({ references, children, showStickyTab = true }) => {
  useEffect(() => {
    const favicon = document.getElementById("favicon");
    favicon.href = hcpFavicon;
  }, []);

  const hasSeenEntryModal = sessionStorage.getItem(
    "is-healthcare-professional"
  );

  const [isEntryModalOpen, setIsEntryModalOpen] = useState(!hasSeenEntryModal);

  return (
    <PageWrapper
      variant="hcp"
      isModalOpen={isEntryModalOpen}
      references={references}
      CTA={SignUpCTA}
    >
      <EntryModal
        isOpen={isEntryModalOpen}
        setIsOpen={setIsEntryModalOpen}
        hasSeenModal={hasSeenEntryModal}
      />
      <BasicHero />
      {children}
      {showStickyTab && <StickyTab />}
      <GradientCta />
    </PageWrapper>
  );
};

export default HCPPageWrapper;
